import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';

// Hash sections keep the hosting document's pathname and query. Settings alone
// uses /settings browser history; fragments inside its routes remain fragments.
export function createDestinationRouter(destination, routes) {
  return createRouter({
    history: destination.mode === 'history' ? createWebHistory(destination.base) : createWebHashHistory(),
    routes,
    linkActiveClass: 'active'
  });
}
